import ApiCaller from './ApiCaller/apiCaller'

export const getTrackingDataByIdentify = (identify) => {
    return new Promise((resolve, reject) => {
        ApiCaller.get("/Tagging?identifier=" + identify)
            .then((response) => {
                resolve(response.data);
            })
            .catch((error) => {
                console.error('ERROR', "/Tagging?identifier=" + identify + " Api responded failed : " + error)
                reject(error)
            });
    });
};
